(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/validator"), require("@splat/constant"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , ], factory);
	else if(typeof exports === 'object')
		exports["textarea"] = factory(require("@splat/validator"), require("@splat/constant"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["textarea"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_validator__, __WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "textAreaClassName": function() { return /* binding */ textAreaClassName; },
/* harmony export */   "inputFailedValidateStatusClassName": function() { return /* binding */ inputFailedValidateStatusClassName; },
/* harmony export */   "inputSuccessValidateStatusClassName": function() { return /* binding */ inputSuccessValidateStatusClassName; },
/* harmony export */   "inputFailedValidateStatusMessageClassName": function() { return /* binding */ inputFailedValidateStatusMessageClassName; },
/* harmony export */   "inputDisabledTextClassName": function() { return /* binding */ inputDisabledTextClassName; },
/* harmony export */   "inputContainerValidateStatusClassName": function() { return /* binding */ inputContainerValidateStatusClassName; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _triangle_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./triangle.svg */ "./src/triangle.svg");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_3__);




var textAreaClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  $nest: {
    '&>textarea.el-textarea__inner': {
      color: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)('#333333'),
      borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.border.toString(),
      paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(9),
      margin: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(0)),
      width: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(230),
      maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100),
      $nest: {
        '&::-webkit-resizer': {
          display: 'none'
        },
        '&::-webkit-input-placeholder': {
          color: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.placeholder.toString())
        }
      }
    },
    '&.el-textarea': {
      width: 'auto',
      maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100)
    },
    '&:before': {
      content: '""',
      backgroundImage: (0,csx__WEBPACK_IMPORTED_MODULE_2__.url)(_triangle_svg__WEBPACK_IMPORTED_MODULE_1__),
      backgroundSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12),
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      width: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12),
      height: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12),
      bottom: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(3),
      right: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(3),
      pointerEvents: 'none'
    }
  }
});
var inputFailedValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  $nest: {
    '& textarea': {
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)('#C55252')
    }
  }
});
var inputSuccessValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  $nest: {
    '& textarea': {
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)('#D9D9D9')
    }
  }
});
var inputFailedValidateStatusMessageClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  position: 'absolute',
  left: 0,
  top: (0,csx__WEBPACK_IMPORTED_MODULE_2__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100), " + ").concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(2))),
  color: '#C55252',
  lineHeight: 1
});
var inputDisabledTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  opacity: 0.5
});
var inputContainerValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  position: 'relative',
  marginBottom: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(10)
});

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "./src/triangle.svg":
/*!**************************!*\
  !*** ./src/triangle.svg ***!
  \**************************/
/***/ (function(module) {

"use strict";
module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTg2NzY1MDE3NjY0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExMDYiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNODE0LjgxMTQyOSA5NTYuMTIzNDI5SDIwNi43MDE3MTRhMTQ2LjI4NTcxNCAxNDYuMjg1NzE0IDAgMCAxLTk3LjU3MjU3MS0yNTUuMjY4NTcybDYwOC40MDIyODYtNTQ0LjYyMTcxNGExNDYuMjg1NzE0IDE0Ni4yODU3MTQgMCAwIDEgMjQzLjg1ODI4NSAxMDguOTgyODU3djU0NC42MjE3MTRhMTQ2LjI4NTcxNCAxNDYuMjg1NzE0IDAgMCAxLTE0Ni4yODU3MTQgMTQ2LjI4NTcxNXoiIGZpbGw9IiNkOWQ5ZDkiIHAtaWQ9IjExMDciPjwvcGF0aD48L3N2Zz4K";

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/validator":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/validator","commonjs2":"@splat/validator"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_validator__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_13__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var TextArea = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(TextArea, _tsx$Component);

  var _super = _createSuper(TextArea);

  function TextArea() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "readonly", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showWordLimit", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "autosize", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "maxlength", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "rows", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "resize", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "noValidate", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "validateState", {
      type: _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.unknown
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_formItemInstance", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(TextArea, [{
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "handleInput",
    value: function handleInput(v) {
      this.onInput(v);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      if (this.formItemInstance && !this.noValidate) {
        this.validateState = this.formItemInstance.onChanged();
      }
    }
  }, {
    key: "formItemInstance",
    get: function get() {
      var _formItemInstance = this._formItemInstance;
      return _formItemInstance ? _formItemInstance() : null;
    }
  }, {
    key: "updateState",
    value: function updateState(v) {
      this.validateState = v;
    }
  }, {
    key: "containerValidateStateClassName",
    get: function get() {
      return this.validateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.failed ? _style__WEBPACK_IMPORTED_MODULE_9__.inputContainerValidateStatusClassName : undefined;
    }
  }, {
    key: "inputValidateStatusClassName",
    get: function get() {
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.failed:
          return _style__WEBPACK_IMPORTED_MODULE_9__.inputFailedValidateStatusClassName;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.success:
          return null;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "renderValidateStatus",
    value: function renderValidateStatus() {
      var h = this.$createElement;
      var validateState = this.validateState,
          disabled = this.disabled;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.failed:
          return h("span", {
            "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.inputFailedValidateStatusMessageClassName, disabled && _style__WEBPACK_IMPORTED_MODULE_9__.inputDisabledTextClassName)
          }, [validateState.error]);

        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.success:
        case _splat_validator__WEBPACK_IMPORTED_MODULE_8__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var value = this.value,
          disabled = this.disabled,
          autosize = this.autosize,
          handleInput = this.handleInput,
          handleChange = this.handleChange,
          placeholder = this.placeholder,
          readonly = this.readonly,
          maxlength = this.maxlength,
          rows = this.rows,
          showWordLimit = this.showWordLimit,
          resize = this.resize,
          renderValidateStatus = this.renderValidateStatus,
          containerValidateStateClassName = this.containerValidateStateClassName,
          inputValidateStatusClassName = this.inputValidateStatusClassName;
      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(containerValidateStateClassName, inputValidateStatusClassName)
      }, [h("el-input", {
        "attrs": {
          "readonly": readonly,
          "disabled": disabled,
          "autosize": autosize,
          "value": value,
          "maxlength": maxlength,
          "type": 'textarea',
          "placeholder": placeholder,
          "rows": rows,
          "showWordLimit": showWordLimit,
          "resize": resize
        },
        "class": _style__WEBPACK_IMPORTED_MODULE_9__.textAreaClassName,
        "on": {
          "input": handleInput,
          "change": handleChange
        }
      }), renderValidateStatus()]);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.formItemInstance && !this.noValidate) {
        this.formItemInstance.setFormComponent(this);
        this.validateState = this.formItemInstance.onMounted();
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.formItemInstance && !this.noValidate) {
        this.formItemInstance.resetFormComponent(this);
      }
    }
  }]);

  return TextArea;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "readonly", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "showWordLimit", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "autosize", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "maxlength", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "rows", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], TextArea.prototype, "resize", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)({
  default: true
})], TextArea.prototype, "noValidate", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Emit)('input')], TextArea.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Inject)({
  from: 'formItemInstance',
  default: null
})], TextArea.prototype, "_formItemInstance", void 0);

TextArea = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Component], TextArea);
/* harmony default export */ __webpack_exports__["default"] = (TextArea);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map